import { render, staticRenderFns } from "./UsernamePassword.vue?vue&type=template&id=fa8f1860&scoped=true"
import script from "./UsernamePassword.vue?vue&type=script&lang=js"
export * from "./UsernamePassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa8f1860",
  null
  
)

export default component.exports